<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.0002 16.75C9.62523 16.75 7.70299 16.0971 6.03837 14.4324C3.25588 11.6499 2.54357 7.85097 4.44738 5.94716C6.01164 4.3829 8.85535 4.5848 11.3634 6.25002M13.83 8.50001C15.9945 10.9984 16.911 13.5465 15.2502 14.875C14.0061 15.8703 12.4318 14.7193 11.5132 13.8321M9.25023 10.75H10.8909C11.2893 10.75 11.6714 10.5915 11.9528 10.3094L15.6921 6.56067C16.2767 5.97467 16.2761 5.02595 15.6908 4.44068L15.5609 4.31068C14.975 3.72489 14.0253 3.72489 13.4395 4.31069L9.68958 8.06068C9.40825 8.34199 9.25023 8.72351 9.25023 9.12131V10.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'CreativeTestsIcon'
}
</script>

